import React from 'react';
import PropTypes from 'prop-types';

import {
    RIQInfoPopover
} from './RIQPopover.jsx';

export default function Label({children, description, title}) {
    title ||= children;

    let infoPopover = null;
    if (description) {
        infoPopover = (
            <span className='tlw-ml-1'>
                <RIQInfoPopover
                    description={description}
                    title={title}
                />
            </span>
        );
    }

    return (
        <h1 className='tlw-mt-0 tlw-text-11 tlw-font-semibold tlw-leading-8 tlw-text-gray-700'>
            <span className='tlw-uppercase'>
                {title}
            </span>
            {infoPopover}
        </h1>
    );
}
Label.propTypes = {
    children: PropTypes.node,
    description: PropTypes.node,
    title: PropTypes.node
};
